import { shouldEnableAutoPublishedProjects } from 'bundles/employability-common/feature-flags/learnerProfileEpicFeatureFlags';

export const useEnableAutoPublishedProjects = () => {
  const enableAutoPublish = shouldEnableAutoPublishedProjects();

  return enableAutoPublish;
};
